import { createSlice } from '@reduxjs/toolkit'

export const footerProviderSlice = createSlice({
	name: 'footerProvider',
	initialState: {
		isContinueActive: false,
		isFooterVisible: false,
		continueUrl: '/orders',
		backUrl: '/orders',
		wasItemsHandled: false,
		cartStateChanged: false,
	},
	reducers: {
		setContinueState: (state, { payload }) => {
			state.isContinueActive = payload.isActive
		},
		showFooter: (state) => {
			state.isFooterVisible = true
		},
		hideFooter: (state) => {
			state.isFooterVisible = false
		},
		setContinueUrl: (state, { payload }) => {
			state.continueUrl = `/${payload}`
		},
		setBackUrl: (state, { payload }) => {
			state.backUrl = `/${payload}`
		},
		setItemsAsHandled: (state, { payload }) => {
			state.wasItemsHandled = payload
		},
		changeCartState: (state, { payload }) => {
			state.cartStateChanged = !state.cartStateChanged
		},
	},
})

export const {
	setContinueState,
	showFooter,
	hideFooter,
	setContinueUrl,
	setBackUrl,
	setItemsAsHandled,
	changeCartState,
} = footerProviderSlice.actions

export const { reducer } = footerProviderSlice
